var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyWeaksignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.0001,
    cy: 78.0001,
    r: 15.795,
    stroke: "#11A0DA",
    strokeWidth: 1.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8457 22.8456C15.6027 30.0886 9.85727 38.6872 5.9374 48.1506C2.01753 57.614 4.86146e-06 67.7568 2.16406e-06 77.9999C4.18711e-06 88.243 2.01753 98.3859 5.9374 107.849C9.85727 117.313 15.6027 125.911 22.8457 133.154L23.9488 132.051C16.8507 124.953 11.2201 116.526 7.37865 107.252C3.53718 97.9781 1.56 88.0382 1.56 77.9999C1.56 67.9617 3.53718 58.0217 7.37865 48.7476C11.2201 39.4735 16.8506 31.0468 23.9488 23.9487L22.8457 22.8456Z",
    fill: "#11A0DA",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.154 22.8456C140.397 30.0886 146.143 38.6872 150.063 48.1506C153.982 57.614 156 67.7568 156 77.9999C156 88.243 153.982 98.3859 150.063 107.849C146.143 117.313 140.397 125.911 133.154 133.154L132.051 132.051C139.149 124.953 144.78 116.526 148.621 107.252C152.463 97.9781 154.44 88.0382 154.44 77.9999C154.44 67.9617 152.463 58.0217 148.621 48.7476C144.78 39.4735 139.149 31.0468 132.051 23.9487L133.154 22.8456Z",
    fill: "#11A0DA",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.54 44.4601C115.945 48.8646 119.438 54.0935 121.822 59.8484C124.206 65.6032 125.433 71.7711 125.433 78.0001C125.433 84.229 124.206 90.397 121.822 96.1518C119.438 101.907 115.945 107.136 111.54 111.54L110.869 110.869C115.186 106.553 118.61 101.428 120.946 95.7888C123.282 90.149 124.484 84.1044 124.484 78.0001C124.484 71.8957 123.282 65.8511 120.946 60.2114C118.61 54.5717 115.186 49.4473 110.869 45.1309L111.54 44.4601Z",
    fill: "#11A0DA",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.46 44.4601C40.0555 48.8646 36.5616 54.0935 34.1779 59.8484C31.7942 65.6032 30.5673 71.7711 30.5673 78.0001C30.5673 84.229 31.7942 90.397 34.1779 96.1518C36.5616 101.907 40.0555 107.136 44.46 111.54L45.1308 110.869C40.8144 106.553 37.3904 101.428 35.0543 95.7888C32.7183 90.149 31.5159 84.1044 31.5159 78.0001C31.5159 71.8957 32.7183 65.8511 35.0543 60.2114C37.3904 54.5717 40.8144 49.4473 45.1308 45.1309L44.46 44.4601Z",
    fill: "#11A0DA",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyWeaksignal);
export default __webpack_public_path__ + "static/media/metodology-weaksignal.6e37a5c89adceba02135b6b89ef3b394.svg";
export { ForwardRef as ReactComponent };